/**
 * React Query hooks for vocabulary operations
 * Provides data fetching and caching for vocabulary
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchRandomWord } from '../services/api';
import type { VocabularyEntry } from '../types';

// React Query cache keys
const QUERY_KEYS = {
  randomWord: ['randomWord'] as const,
} as const;

/**
 * Fetch a random word from the vocabulary
 * Uses React Query mutation for state management
 * @returns Mutation hook with loading state and data
 */
export function useGetRandomWord() {
  const queryClient = useQueryClient();

  return useMutation<VocabularyEntry | null, Error, void>({
    mutationFn: async () => fetchRandomWord(),
    onSuccess: () => {
      // Invalidate cache to allow fresh fetches
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.randomWord });
    },
  });
}
